import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Sun, FolderOpen, Timer, Sparkles, Plus } from "lucide-react";

const items = [
  { to: "/today", label: "Aujourd'hui", icon: Sun, testId: "nav-today" },
  { to: "/projects", label: "Projets", icon: FolderOpen, testId: "nav-projects" },
  { to: "/focus", label: "Focus", icon: Timer, testId: "nav-focus" },
  { to: "/reset", label: "Reset", icon: Sparkles, testId: "nav-reset" },
];

export const BottomNav: React.FC<{ onCapture: () => void }> = ({ onCapture }) => {
  const location = useLocation();
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 bg-white/80 backdrop-blur-xl border-t border-forest-900/5 pb-safe pt-2.5 px-2"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around">
        {items.slice(0, 2).map((item) => (
          <NavItem key={item.to} {...item} active={location.pathname.startsWith(item.to)} />
        ))}

        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={onCapture}
          data-testid="quick-capture-fab"
          aria-label="Capture rapide"
          className="-mt-8 h-14 w-14 rounded-full bg-sage text-white flex items-center justify-center shadow-[0_8px_24px_rgba(138,154,134,0.45)] shrink-0"
        >
          <Plus strokeWidth={2} className="h-6 w-6" />
        </motion.button>

        {items.slice(2).map((item) => (
          <NavItem key={item.to} {...item} active={location.pathname.startsWith(item.to)} />
        ))}
      </div>
    </nav>
  );
};

const NavItem: React.FC<{
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string; strokeWidth?: number }>;
  testId: string;
  active: boolean;
}> = ({ to, label, icon: Icon, testId, active }) => (
  <NavLink
    to={to}
    data-testid={testId}
    className="flex flex-col items-center gap-1 w-16 py-1 transition-colors"
  >
    <Icon strokeWidth={1.75} className={`h-6 w-6 ${active ? "text-sage-dark" : "text-forest-500"}`} />
    <span
      className={`text-[10px] tracking-wide ${
        active ? "text-sage-dark font-semibold" : "text-forest-500"
      }`}
    >
      {label}
    </span>
  </NavLink>
);
